import '../../styles/common/Footer.scss';

const Footer = () => {
  return (
    <div className="footer">
      Hecho por
      <a
        href="https://storrecu.github.io/Portfolio/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Silvia Torres
      </a>
    </div>
  );
};

export default Footer;
